"use client";

import { InfoTextWithVideoBlockSection } from "@/components/organisms/pb-sections/InfoTextWithVideoBlockSection";
import { InfoTextWithVideoBlockProps } from "./types";
import { ModalProvider } from "@ama-pt/agora-design-system";

export default function InfoTextWithVideoBlock(data: InfoTextWithVideoBlockProps) {
  return (
    <div>
      <ModalProvider>
        <InfoTextWithVideoBlockSection
          {...data}
        />
      </ModalProvider>
    </div>
  );
};
